import type { ScmProviderId } from '@/types/scm-provider';
import { scmPost } from './scmClient';

export interface PipelineStage {
  name: string;
  order: string;
}

interface PipelineStagesResponse {
  data: {
    pipelineId: number;
    pipelineName: string;
    stages: PipelineStage[];
  };
}

interface RequestBody {
  provider: ScmProviderId;
  body: {
    organization: string;
    project: string;
    pipelineId: string;
    orgUrl: string;
  };
  requesterToken: { patToken: string };
}

export const getPipelineStages = ({
  provider,
  body,
  requesterToken,
}: RequestBody): Promise<PipelineStagesResponse> => {
  return scmPost(provider, '/api/scm/workflow-jobs', requesterToken.patToken, {
    organization: body.organization,
    project: body.project,
    repository: '',
    workflowId: body.pipelineId,
  });
};
